var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-title"},[_vm._v(_vm._s(_vm.$t(("ROUTE_NAME." + _vm.title)))+"\n  "),(_vm.fabExists)?_c('Fab',{attrs:{"fabList":_vm.fabList,"routeName":_vm.title}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae13269e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageTitle.vue
// module id = 920
// module chunks = 1